import type { FunctionComponent, ReactNode } from "react";

type StepWrapperProps = {
  children: ReactNode | ReactNode[];
};

/**
 * StepWrapper is the default wrapper component for all steps and makes sure all steps have the same padding and margin.
 * @param children The child elements of the wrapper.
 * @constructor
 */
export const StepWrapper: FunctionComponent<StepWrapperProps> = ({
  children,
}: StepWrapperProps) => {
  return <div className={`md:w-80 mt-2 mb-4`}>{children}</div>;
};
